
import React from "react";
import {
    Button,
    Card,
    Col,
    notification,
    Popconfirm,
    Row,
    Tooltip,
    Drawer,
    Form
} from "antd";
import Request, { API_URL } from "../../../request";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import { TableComp, FormUtils as GetAllFormFields } from "sz-react-utils";
import _ from 'lodash'

@Form.create()
class EditAddDegree extends React.Component {
    state = {
        visible: true
    }


    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = (e) => {
        let { form, record } = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            let x = null
            if (record && record._id) {
                values._id = record._id;
                x = await Request.updateTypeOfDegree(values)
            } else {
                x = await Request.addTypeOfDegree(values)
            }
            if (x.success) {
                notification.success({
                    message: x.message
                })
            } else {
                notification.error({
                    message: x.message
                })
            }
            this.onClose()
        })
    }

    componentDidMount() {
        let { record, form: { setFieldsValue } } = this.props
        if (record && record._id) {
            setTimeout(() => {
                setFieldsValue(record)
            }, 50)
        }
    }

    render() {
        let { visible } = this.state;
        let { form: { getFieldDecorator, setFieldsValue }, record } = this.props
        let inputTypes = {
            fields: [
                {
                    label: 'Degree Name',
                    key: 'degreeName',
                    type: 'text'
                },
                {
                    label: 'Qualification Level',
                    key: 'qualification',
                    type: 'select',
                    options: ["Bachelor Degree", "Diploma", "Master Degree"],
                    onChange: v => {
                        setFieldsValue({ qualification: v })
                    }
                }
            ]
        }
        return (
            <Drawer
                title={`${this.props.record && this.props.record._id ? "Update" : "Add"} Type Of Degree`}
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}
            >
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields apiurl={API_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}



class TypeOfDegree extends React.Component {
    state = {
        count: 0,
        showDegreeDrawer: false,
        record: {}
    }


    showAddDrawer = () => {
        this.setState({ showDegreeDrawer: true })
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    closeDegreeDrawer = () => {
        this.setState({ showDegreeDrawer: false, record: {} }, () => {
            this.reload()
        })
    }


    componentDidMount() {

    }

    reload() {
        this.table.current.reload()
    }

    editTypeOfDegree = (record) => {
        this.setState({ showDegreeDrawer: true, record: record })
    }

    deleteTypeOfDegree = async (recordId) => {
        let response = await Request.deleteTypeOfDegree(recordId)
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.reload()
    }

    apiRequest = async (params) => {
        return new Promise(async (resolve) => {
            params.sortField = "degreeName";
            params.sortOrder = "ascend";
            params.deleted = false;
            let response = await Request.getAllTypeOfDegrees(params);
            this.setState({count:response.total});
            resolve(response);
        })
    }

    render() {
        // Table Columns
        const columns = [
            {
                title: 'Degree Name',
                key: 'degreeName',
                searchTextName:'Degree Name',
                filterRegex: true
            },
            {
                title: 'Qualification',
                key: 'qualification',
                filters: [
                    {value: 'Diploma', text: 'Diploma'},
                    {value: 'Bachelor Degree', text: 'Bachelor Degree'},
                    {value: 'Master Degree', text: 'Master Degree'}
                ],
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <>
                        <Tooltip title={"Edit Degree"}>

                            <Button size="small" onClick={() => this.editTypeOfDegree(record)} shape="circle" icon="edit" />
                        </Tooltip>
                        <Tooltip title={"Delete Degree"}>
                            <Popconfirm title="Are you sure to delete this Type of Degree?"
                                onConfirm={() => {
                                    this.deleteTypeOfDegree(record._id)
                                }}
                                okText="Yes"
                                cancelText="No">
                                <Button shape="circle" size="small" icon="delete" />
                            </Popconfirm>

                        </Tooltip>
                    </>
                )
            }
        ]



        return (
            <PageHeaderWrapper title={`Type of Degrees : ${this.state.count}`}>
                {
                    this.state.showDegreeDrawer ?
                        <EditAddDegree record={this.state.record} onClose={this.closeDegreeDrawer} />
                        : null
                }
                <Card style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={12}>
                        </Col>
                        <Col span={10}>
                        </Col>
                        <Col span={2}>
                            <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                <Button onClick={() => this.showAddDrawer()}>Add</Button>
                            </div>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ["10", "20", "50", "100", "1000"],
                        }}
                    />
                </Card>

            </PageHeaderWrapper>
        )
    }
}




const mapStateToProps = ({ global }) => ({
    categories: global.categories,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TypeOfDegree);